import Vue from 'vue';
import Router from 'vue-router';
import AppDownload from './views/AppDownload.vue';
import Root from './views/Root.vue';

Vue.use(Router);

const $router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Root',
      component: Root,
      meta: {},
    },
    {
      path: '/us_ca_art',
      name: 'AppDownload',
      component: AppDownload,
      meta: {},
    },
    {
      path: '/testagency',
      name: 'AppDownload',
      component: AppDownload,
      meta: {},
    },
  ],
});

$router.beforeEach((to, from, next) => {
  document.title = (to.meta.title) ? `${to.meta.title}` : 'Transfer';
  const paths = (to.fullPath) ? to.fullPath.split('/') : [];
  if (paths.length > 2) {
    next({ path: `/${paths[1]}` });
  } else {
    next();
  }
});

export default $router;
